import {
  FrontendApiGetRecoveryFlowRequest,
  FrontendApiUpdateLoginFlowRequest,
  FrontendApiUpdateRecoveryFlowRequest,
  FrontendApiUpdateSettingsFlowRequest,
  LoginFlow,
  RecoveryFlow,
  SettingsFlow,
  SuccessfulNativeLogin,
} from '@ory/kratos-client/api';
import { NavigateFunction } from 'react-router/dist/lib/hooks';
import { kratosClient } from 'common/clients/kratos.client';
import { queryClient } from 'common/clients/query.client';
import { removeFromLocalstorage, setToLocalstorage } from 'common/utils/local-storage.utils';
import { ROUTES_MAPPING } from 'navigation/constants/route.constants';
import { EAuthFlagName } from '../constants/auth.constants';

export const authCreateLoginFlow = async (): Promise<LoginFlow> => {
  const { data } = await kratosClient.createBrowserLoginFlow();

  return data;
};

export const authUpdateLoginFlow = async (
  reqData: FrontendApiUpdateLoginFlowRequest
): Promise<SuccessfulNativeLogin> => {
  const { data } = await kratosClient.updateLoginFlow(reqData);

  setToLocalstorage(EAuthFlagName, 'true');

  return data;
};

export const authCreateRecoveryFlow = async (): Promise<RecoveryFlow> => {
  const { data } = await kratosClient.createBrowserRecoveryFlow();

  return data;
};

export const authUpdateRecoveryFlow = async (
  reqData: FrontendApiUpdateRecoveryFlowRequest
): Promise<RecoveryFlow> => {
  const response = await kratosClient.updateRecoveryFlow(reqData);

  return response?.data;
};

export const authGetRecoveryFlow = async (
  reqData: FrontendApiGetRecoveryFlowRequest
): Promise<RecoveryFlow> => {
  const { data } = await kratosClient.getRecoveryFlow(reqData);

  return data;
};

export const authCreateSettingsFlow = async (): Promise<SettingsFlow> => {
  const { data } = await kratosClient.createBrowserSettingsFlow();

  return data;
};

export const authUpdateSettingsFlow = async (
  reqData: FrontendApiUpdateSettingsFlowRequest
): Promise<SettingsFlow> => {
  const { data } = await kratosClient.updateSettingsFlow(reqData);

  return data;
};

export const authLogoutFlow = async (navigate: NavigateFunction, redirect: boolean = true): Promise<void> => {
  const { data: logoutFlow } = await kratosClient.createBrowserLogoutFlow();

  await kratosClient.updateLogoutFlow({
    token: logoutFlow.logout_token,
  });

  removeFromLocalstorage(EAuthFlagName);

  queryClient.clear();

  if (redirect) navigate(ROUTES_MAPPING.PUBLIC.LOGIN);
};
